import { render, staticRenderFns } from "./input-text-area.vue?vue&type=template&id=398e97da&scoped=true&"
import script from "./input-text-area.component.ts?vue&type=script&lang=ts&"
export * from "./input-text-area.component.ts?vue&type=script&lang=ts&"
import style0 from "./input-text-area.vue?vue&type=style&index=0&id=398e97da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398e97da",
  null
  
)

export default component.exports